import React, {Component} from "react";

class WorkflowError extends Component {
    render() {
        return (
            <React.Fragment>
                {this.props.workflow.errors.map(error => (
                    <div id={"coreWorkflow-itemError-" + error.id + "-" + error.index} key={"coreWorkflow-itemError-" + error.id + "-" + error.index}
                         className="coreWorkflow-itemError">
                        <p className="coreWorkflow-itemErrorMessage">{error.content}</p>
                    </div>
                ))}

                {this.props.workflow.warnings.map(warning => (
                    <div id={"coreWorkflow-itemWarning-" + warning.id + "-" + warning.index} key={"coreWorkflow-itemWarning-" + warning.id + "-" + warning.index}
                         className="coreWorkflow-itemWarning">
                        <p className="coreWorkflow-itemWarningMessage">{warning.content}</p>
                    </div>
                ))}

                {this.props.workflow.infos.map(info => (
                    <div id={"coreWorkflow-itemInfo-" + info.id + "-" + info.index} key={"coreWorkflow-itemInfo-" + info.id + "-" + info.index}
                         className="coreWorkflow-itemInfo">
                        <p className="coreWorkflow-itemInfoMessage">{info.content}</p>
                    </div>
                ))}
            </React.Fragment>
        );
    }
}

export default WorkflowError;